// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'card-stack-solid';

export const Component = () => (
  <path d='M24.522 3.485v8.813c0 .43-.144.766-.431 1.054a1.408 1.408 0 0 1-1.054.43H1.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 0 12.298V3.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 1.485 2h21.552c.431 0 .766.144 1.054.431.287.288.43.623.43 1.054Zm-2.442 12.26H2.444c-.335 0-.48.144-.48.48 0 .334.145.478.48.478H22.08c.335 0 .479-.144.479-.479 0-.335-.144-.479-.48-.479Zm-1.964 2.922H4.407c-.335 0-.479.144-.479.48 0 .334.144.526.479.526h15.709c.335 0 .479-.192.479-.527s-.144-.479-.48-.479Zm-1.964 2.97H6.372c-.336 0-.48.143-.48.479 0 .335.144.479.48.479h11.78c.335 0 .48-.144.48-.48 0-.335-.145-.478-.48-.478Z' />
);

export const viewBox = '0 0 25 25';
